module.exports = __webpack_public_path__ + "a443af673bba66317d989a6c6d8cff2b.svg";